import React from 'react';
import { Elevate2026 } from '../views';

const ExtraCurricularActivitiesPage = () => {
  return <Elevate2026 />;
};

export default ExtraCurricularActivitiesPage;